export const SUCCESS_DEFAULT = 'neo-trading/dashboard/SUCCESS_DEFAULT';
export const FAILURE_DEFAULT = 'neo-trading/dashboard/FAILURE_DEFAULT';
export const LOAD_NEWSFEEDCOMPONENT = 'neo-trading/dashboard/LOAD_NEWSFEEDCOMPONENT';
export const LOAD_NEWSFEED = 'neo-trading/dashboard/LOAD_NEWSFEED';
export const LOAD_NEWSFEED_SUCCESS = 'neo-trading/dashboard/LOAD_NEWSFEED_SUCCESS';
export const LOAD_NEWSFEED_FAILURE = 'neo-trading/dashboard/LOAD_NEWSFEED_FAILURE';
export const UPDATE_NEWSFEED ='neo-trading/dashboard/UPDATE_NEWSFEED';
